import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Post from "../components/post"
import Pagination from "../components/pagination"
import Seo from "../components/seo"

import * as styles from "../styles/archive.module.css"

const ArchivePage = ({ data, pageContext }) => {
  const archiveTitle =
    pageContext.type === "category"
      ? data.categoryJson.title
      : data.tagJson.title

  const copyHandler = () => {
    let copiedText = ""
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*()"
    for (let i = 0; i < 10 ; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length)
      copiedText += chars[randomIndex]
    }
    navigator.clipboard.writeText(copiedText)
  }

  return (
    <Layout>
      <main className={styles.archive} onCopy={copyHandler}>
        <div className={styles.archiveHeader}>
          <div className="w-container">
            <h1 className={styles.archiveHeading}>{archiveTitle}</h1>
          </div>
        </div>

        <div className="w-container">
          <ul className="p-postList -type-card">
            {pageContext.type === "category" &&
              data.allMarkdownRemarkCategory.nodes.map(post => (
                <li key={post.id}>
                  <Post post={post} date />
                </li>
              ))}
            {pageContext.type === "tag" &&
              data.allMarkdownRemarkTag.nodes.map(post => (
                <li key={post.id}>
                  <Post post={post} date category />
                </li>
              ))}
          </ul>
          {pageContext.pages > 1 && <Pagination pageContext={pageContext} />}
        </div>
      </main>
    </Layout>
  )
}

export const Head = ({ data, pageContext, location }) => {
  const pagetitle =
    pageContext.type === "category"
      ? data.categoryJson.title
      : data.tagJson.title

  const pagedesc =
    pageContext.type === "category"
      ? data.allMarkdownRemarkCategory.nodes[0].frontmatter.title
      : data.allMarkdownRemarkTag.nodes[0].frontmatter.title
  const schema = [
    {
      "@type": "CollectionPage",
      "@id": data.site.siteMetadata.siteUrl + location.pathname,
      url: data.site.siteMetadata.siteUrl + location.pathname,
      name: `${pagetitle} 記事一覧 | ${data.site.siteMetadata.title}`,
      isPartOf: { "@id": `${data.site.siteMetadata.siteUrl}/#website` },
      primaryImageOfPage: {
        "@id":
          data.site.siteMetadata.siteUrl + location.pathname + `#primaryimage`,
      },
      image: {
        "@id":
          data.site.siteMetadata.siteUrl + location.pathname + `#primaryimage`,
      },
      thumbnailUrl:
        data.site.siteMetadata.siteUrl + data.file.childImageSharp.original.src,
      breadcrumb: {
        "@id":
          data.site.siteMetadata.siteUrl + location.pathname + `#breadcrumb`,
      },
      inLanguage: "ja",
    },
    {
      "@type": "ImageObject",
      inLanguage: "ja",
      "@id":
        data.site.siteMetadata.siteUrl + location.pathname + `#primaryimage`,
      url:
        data.site.siteMetadata.siteUrl + data.file.childImageSharp.original.src,
      contentUrl:
        data.site.siteMetadata.siteUrl + data.file.childImageSharp.original.src,
      width: data.file.childImageSharp.original.width,
      height: data.file.childImageSharp.original.height,
    },
    {
      "@type": "BreadcrumbList",
      "@id": data.site.siteMetadata.siteUrl + location.pathname + `#breadcrumb`,
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "ホーム",
          item: data.site.siteMetadata.siteUrl,
        },
        { "@type": "ListItem", position: 2, name: pagetitle },
      ],
    },
  ]

  return (
    <Seo
      pagetitle={`${pagetitle} 記事一覧`}
      pagedesc={`${pagetitle}に関する記事一覧です。${pagedesc}`}
      pagepath={location.pathname}
      pagetype="article"
      pageSchema={schema}
    />
  )
}

export const query = graphql`
  query (
    $catSlug: [String!]!
    $tagSlug: [String!]!
    $skip: Int!
    $limit: Int!
  ) {
    allMarkdownRemarkCategory: allMarkdownRemark(
      filter: {
        frontmatter: {
          categories: { elemMatch: { slug: { in: $catSlug } } }
          draft: { eq: false }
        }
      }
      limit: $limit
      skip: $skip
      sort: { frontmatter: { date: DESC } }
    ) {
      nodes {
        excerpt(pruneLength: 80, truncate: true)
        id
        frontmatter {
          title
          categories {
            title
            color
          }
          date
          dateJP: date(formatString: "YYYY.M.D")
          lastmod
          lastmodJP: lastmod(formatString: "YYYY.M.D")
          image {
            childImageSharp {
              gatsbyImageData(width: 540)
            }
          }
        }
        parent {
          ... on File {
            name
          }
        }
      }
    }
    allMarkdownRemarkTag: allMarkdownRemark(
      filter: {
        frontmatter: {
          tags: { elemMatch: { slug: { in: $tagSlug } } }
          draft: { eq: false }
        }
      }
      limit: $limit
      skip: $skip
      sort: { frontmatter: { date: DESC } }
    ) {
      nodes {
        excerpt(pruneLength: 80, truncate: true)
        id
        frontmatter {
          title
          categories {
            title
            color
          }
          date
          dateJP: date(formatString: "YYYY.M.D")
          lastmod
          lastmodJP: lastmod(formatString: "YYYY.M.D")
          image {
            childImageSharp {
              gatsbyImageData(width: 540)
            }
          }
        }
        parent {
          ... on File {
            name
          }
        }
      }
    }
    categoryJson(slug: { in: $catSlug }) {
      title
      color
    }
    tagJson(slug: { in: $tagSlug }) {
      title
    }
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    file(name: { eq: "tax-return-06" }) {
      id
      childImageSharp {
        original {
          src
          width
          height
        }
      }
    }
  }
`
export default ArchivePage
